import React from 'react'
import Layout from '../../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const TextileAbrasionTester = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000
    };

    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2FTextileTesting%2Fimg%2F4.png?alt=media&token=4a772a1f-7241-4f94-873d-d63da568702c',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2FTextileTesting%2Fimg%2F4.png?alt=media&token=4a772a1f-7241-4f94-873d-d63da568702c'
    ];

    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/textile">Textile</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Abrasion Tester</h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Abrasion Tester</h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                    The Abrasion Tester (Abrader) is mainly composed of one specimen clamping disk, two grinding wheels and two vacuum nozzles. The specimen clamp with two wheels above the disk can be combined with different load weights on the specimen. The Abraser conforms to abrasion tests such as ASTM D3884, ASTM D4060, ASTM D1044 and ISO 5470, and is suitable for various materials including paper, cloth, panel, carpet, glass, rubber, plastic and other materials.
                                    <br /><br />
                                    Industry Applications: Rubber, plastic, textile, cloth, paper and construction material.
                                    <br /><br />
                                    Conforms to Standards: ASTM D3384, ASTM D1175, ASTM D1044, ASTM D4060, TAPPI T476, ISO 9352, ISO 5470-1, JIS K7204, JIS A1453, JIS K6902, JIS L1096, JIS K6964, DIN 52347, DIN 53109, DIN 53754, DIN 53799.
                                    <br /><br />
                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Abrasion Tester"
                                        style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>
                    </div>
                </div>
            </section>
            <br /><br /><br /><br />
        </Layout>
    )
}

export default TextileAbrasionTester
